import { useStaticQuery, graphql } from 'gatsby'

const useTestimonials = () => {
  const data = useStaticQuery(graphql`
    {
      allWpTestimonial {
        nodes {
          testimonial {
            rating
            quote
            name
            video {
              url
              coverPhoto {
                ...LocalImageFrag
              }
            }
          }
        }
      }
    }
  `)
  return data.allWpTestimonial.nodes
}

export default useTestimonials
